<svelte:options accessors/>
<script lang="ts">
    import NauiInput from "../../naui/atoms/NauiInput.svelte";
    import NauiSelect from "../../naui/atoms/NauiSelect.svelte";
    import NauiButton from "../../naui/atoms/NauiButton.svelte";

    export let datos = '';
    export let contacto = {};

</script>
<div>
    <fieldset>
        <legend>Mis datos</legend>
        <div class="grid-auto-1 gap-3">
            <table class="w-max-content mr-3">
                <tr>
                    <td>Nombres</td>
                    <td><strong>{datos['nombres']}</strong></td>
                </tr>
                <tr>
                    <td>Apellidos</td>
                    <td><strong>{datos['apellidos']}</strong></td>
                </tr>
                <tr>
                    <td>Cédula de ciudadanía</td>
                    <td><strong>{datos['cc']}</strong></td>
                </tr>
                <tr>
                    <td>Fecha de nacimiento</td>
                    <td><strong>{datos['fecha_nacimiento']}</strong></td>
                </tr>
            </table>
            <div>
            <div class="pointer box sx-ii border radius p-i px-1 w-max-content mb-1 ">
                <img src="/static/pagos_app/pix/menu-productos.svg" height="30" alt="">
                <strong>Mis productos</strong>
                <span class="material-icons-outlined orange">chevron_right</span>
            </div>
                <div class="back-gray radius p-ii">
                    <p><small style="font-weight: bold">Si alguno de estos es incorrecto por favor <a class="orange" href="">envíe una PQRF</a> solicitando la corrección</small></p>
                </div>
                </div>
        </div>
    </fieldset>
    <fieldset>
        <legend>Información de contacto</legend>
        <div class="grid-5 gap-1 mb-1">
            <NauiInput bind:value={contacto.email} label="Correo" />
            <NauiInput bind:value={contacto.telefono_1} label="Teléfono 1" />
            <NauiInput bind:value={contacto.telefono_2} label="Teléfono 2" />
            <NauiSelect bind:value={contacto.depto} label="Departamento" options="[]" />
            <NauiSelect bind:value={contacto.ciudad}  label="Ciudad" options="[]" />
        </div>
        <div class="grid-5 gap-1">
            <div class="col-2">
                <NauiInput bind:value={contacto.direccion}  label="Dirección residencia" />
            </div>
            <NauiInput bind:value={contacto.barrio}  label="Barrio" />
        </div>
    </fieldset>
    <NauiButton color="accent" mode="solid" caption="Actualizar datos" />
</div>
<style>
    table td{
        padding: .5rem;
    }
</style>